import React, { useState, useEffect } from 'react';

export default function AdminUtmPage() {
  const [novels, setNovels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState({}); // novelId -> slug string
  const [saved, setSaved] = useState({});
  const [errors, setErrors] = useState({}); // novelId -> error message

  async function load() {
    const res = await fetch('/api/admin/utm', { credentials: 'include' });
    const data = await res.json();
    setNovels(Array.isArray(data) ? data : []);
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  async function saveSlug(novelId) {
    const slug = editing[novelId] ?? '';
    setErrors(p => ({ ...p, [novelId]: '' }));
    let error = '';
    try {
      const res = await fetch(`/api/admin/utm/${novelId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ tpt_slug: slug }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        error = data.error || 'Something went wrong. Please try again.';
      }
    } catch {
      error = 'Could not reach the server. Please try again.';
    }
    // Keep the row in edit mode on failure so the slug isn't lost
    if (error) { setErrors(p => ({ ...p, [novelId]: error })); return; }
    setSaved(p => ({ ...p, [novelId]: true }));
    setTimeout(() => setSaved(p => ({ ...p, [novelId]: false })), 2000);
    setEditing(p => { const n = { ...p }; delete n[novelId]; return n; });
    load();
  }

  return (
    <>
      <h1 style={s.h1}>UTM Mappings</h1>
      <p style={s.sub}>
        These slugs map the <code>?novel=</code> URL parameter to a library novel.<br />
        Example: <code>classroom.bingo/play?novel=frindle</code> → Frindle
      </p>

      {loading ? <p style={s.muted}>Loading…</p> : (
        <table style={s.table}>
          <thead>
            <tr>
              {['Novel', 'Status', '?novel= slug', ''].map(h => <th key={h} style={s.th}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {novels.map(n => {
              const isEditing = n.id in editing;
              const currentSlug = isEditing ? editing[n.id] : (n.tpt_slug || '');
              return (
                <tr key={n.id} style={s.tr}>
                  <td style={s.td}>{n.title}</td>
                  <td style={s.td}>
                    <span style={{ ...s.badge, ...(n.active ? s.badgeGreen : s.badgeGray) }}>
                      {n.active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td style={s.td}>
                    <input
                      value={currentSlug}
                      onChange={e => setEditing(p => ({ ...p, [n.id]: e.target.value }))}
                      onFocus={() => !isEditing && setEditing(p => ({ ...p, [n.id]: n.tpt_slug || '' }))}
                      placeholder="none"
                      style={s.slugInput}
                    />
                  </td>
                  <td style={s.td}>
                    {isEditing && (
                      <button onClick={() => saveSlug(n.id)} style={s.saveBtn}>Save</button>
                    )}
                    {saved[n.id] && <span style={s.ok}>Saved</span>}
                    {errors[n.id] && <span style={s.error}>{errors[n.id]}</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}

const s = {
  h1: { fontSize: '22px', fontWeight: '700', color: '#111827', margin: '0 0 8px' },
  sub: { fontSize: '14px', color: '#6b7280', marginBottom: '24px', lineHeight: '1.6' },
  muted: { color: '#6b7280' },
  table: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff',
    border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' },
  th: { padding: '10px 16px', textAlign: 'left', fontSize: '12px', fontWeight: '600',
    color: '#6b7280', textTransform: 'uppercase', backgroundColor: '#f9fafb',
    borderBottom: '1px solid #e5e7eb' },
  tr: { borderBottom: '1px solid #f3f4f6' },
  td: { padding: '12px 16px', fontSize: '14px', color: '#374151' },
  slugInput: { padding: '6px 10px', border: '1px solid #d1d5db', borderRadius: '6px',
    fontSize: '14px', fontFamily: 'monospace', width: '160px' },
  saveBtn: { padding: '6px 14px', backgroundColor: '#16a34a', color: '#fff', border: 'none',
    borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
  ok: { marginLeft: '8px', color: '#16a34a', fontSize: '13px', fontWeight: '600' },
  error: { marginLeft: '8px', color: '#dc2626', fontSize: '13px' },
  badge: { padding: '2px 8px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' },
  badgeGreen: { backgroundColor: '#dcfce7', color: '#15803d' },
  badgeGray: { backgroundColor: '#f3f4f6', color: '#6b7280' },
};
